import React from "react";
import { chunkArray } from "../Utility/function";
import { Document, Page, Text, View, StyleSheet, PDFViewer, PDFDownloadLink, Font, Image  } from '@react-pdf/renderer';
import Prompt from "../assets/fonts/Sarabun/Prompt-Bold.ttf";
import { colors } from "../configs";
import { stringFullDate } from "../Utility/dateTime";

const { one, white } = colors;

const styles = StyleSheet.create({
  oneLineText: {
    fontSize: 8,
    // whiteSpace: 'nowrap', // Prevent line wrap (sometimes works)
    overflow: 'hidden',
    // textOverflow: 'ellipsis', // Only works in some viewers
    // maxLines: 1,
  },
});

Font.register(
  {
    family: "Prompt",
    src: Prompt,
  }
);

function MiniWithPro({
    data
}) {

    const isThaiConsonant = (char) => {
  const code = char.charCodeAt(0);
  return (code >= 0x0E01 && code <= 0x0E2E); // พยัญชนะไทย ก-ฮ
};

const cutThaiTextByConsonants = (text, maxConsonants) => {
  let result = '';
  let count = 0;
  for (let char of text) {
    if (isThaiConsonant(char)) {
      count++;
    }
    result += char;
    if (count >= maxConsonants) break;
  }
  return result;
};

  return    <Document style={{ fontFamily: "Prompt", fontSize:13  }} >
                {chunkArray(data,45).map((item,index)=>{
                    return <Page size="A4" key={index}  >
                            <View style={{ flexWrap:'wrap', flexDirection:'row', marginLeft:10, marginTop:10}} >
                                {item.map((a,i)=>{
                                    const { name, unit, price, promotion:{ qty, endDate, price:promotionPrice }, barcode, barcodeImage } = a;
                                    const normalPrice = qty*price
                                    
                                    return <View key={i} style={{width:"110px",alignItems:'center', borderWidth:0.5}} >
                                                <View style={{backgroundColor:one, width:'100%', height:"22px", justifyContent:'center', alignItems:'center', color:white }} >
                                                    <Text style={{ fontSize:14.5 }} numberOfLines={2} >ลดพิเศษ</Text>
                                                </View>
                                                <View style={{width:'100%', paddingLeft:5, height:30, paddingRight:5}} >
                                               
                                                    <Text style={styles.oneLineText} >
                                                    {cutThaiTextByConsonants(name,12)}
                                                    </Text>
                                                    {/* <Text style={{ fontSize:8, marginTop:-1, overflow: "hidden" }} >{name.slice(0,25)}</Text> */}
                                                    {/* <Text style={{ fontSize:8, marginTop:-7, overflow: "hidden" }} >{name.slice(0,30)}</Text> */}
                                                    <Text style={{ fontSize:7 }}>{qty} {unit} ปกติราคา <Text style={{textDecoration:'line-through'}} >{normalPrice}</Text> บาท</Text>
                                                </View>
                                                <Text style={{ fontSize:20, color:one, marginTop:-10, marginBottom:-10 }}>{promotionPrice}</Text>
                                                <Text style={{ fontSize:7 }} >ราคานี้ จนถึง {stringFullDate(endDate)}</Text>
                                                <Text style={{ fontSize:5 }} >{barcode}</Text>
                                                {barcodeImage && <Image style={{ width:'50px'}} src={barcodeImage} />}
                                            </View>
                                            })}
                            </View>
                        </Page>
                })}

            </Document>
}

export default MiniWithPro;
